/* eslint-disable sonarjs/cognitive-complexity, sonarjs/no-identical-functions, no-nested-ternary, @typescript-eslint/no-unused-vars, @typescript-eslint/ban-ts-comment, sonarjs/no-duplicate-string */
// @ts-nocheck — production refactored (printPdfMake extraction), re-type as follow-up
import dayjs from 'dayjs'
import logo from 'assets/images/logo-black.png'
import getDataUri from './getDataUri'
import textToBase64Barcode from './textToBase64'
import { toastFailed } from './toast'

const printPdfMake = (documentDefinition) => {
  try {
    const { pdfMake } = window
    const frame = window.frames?.printPdf
    const frameEl = document.getElementById('printPdf')
    const pdf = pdfMake.createPdf(documentDefinition)

    if (!frame || !frameEl) {
      pdf.print()
      return
    }

    frameEl.onload = () => {
      try {
        frame.focus()
        frame.print()
      } finally {
        frameEl.onload = null
      }
    }

    pdf.open({}, frame)
  } catch (error) {
    toastFailed('Gagal membuka dialog print')
    // eslint-disable-next-line no-console
    console.error('printPdfMake error:', error)
  }
}

export const printPickListDocument = (picker) => {
  if (!window.pdfMake) {
    toastFailed('PdfMake is not ready')
    return
  }

  getDataUri(logo, function (dataUri) {
    const barcode = textToBase64Barcode(picker.order_invoice)
    const orderCreatedAt = dayjs(picker.order_created_at).format('DD MMM YYYY, HH:mm:ss')
    const headerTable = ['RAK', 'NOMOR SKU', 'NAMA PRODUK', 'QTY']
    const dataTable = picker.order_line_items.map((each) => {
      const {
        order_product_name,
        order_product_rack,
        order_product_quantity,
        order_product_sku,
        cloud_kitchen,
        brand_name,
      } = each

      return [
        {
          border: [true, false, true, true],
          text: (cloud_kitchen ? `  ${brand_name}  ` : order_product_rack) || '-',
          style: cloud_kitchen ? 'blockedText' : 'tableText',
        },
        {
          border: [false, false, true, true],
          text: order_product_sku || '-',
          style: 'tableText',
        },
        {
          border: [false, false, true, true],
          text: order_product_name || '-',
          style: 'tableText',
        },
        {
          border: [false, false, true, true],
          text: order_product_quantity || 0,
          style: 'tableText',
        },
      ]
    })

    const bodyDataIntoTable = [headerTable, ...dataTable]
    const pageMargins = picker.order_note?.length >= 180 ? 165 : 130
    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [20, pageMargins, 20, 20],
      pageOrientation: 'portrait',
      footer(currentPage, pageCount) {
        return {
          columns: [
            {
              fontSize: 9,
              text: [
                {
                  text: `${picker.order_invoice} | ${currentPage.toString()} of ${pageCount}`,
                },
              ],
              alignment: 'center',
            },
          ],
        }
      },
      header: {
        alignment: 'justify',
        margin: [20, 10, 20, 20],
        columns: [
          [
            {
              columns: [
                [
                  {
                    image: dataUri,
                    width: 80,
                    margin: [0, 10, 0, 0],
                  },
                  {
                    style: 'header',
                    text: picker.order_invoice,
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: orderCreatedAt,
                    margin: [0, 5, 0, 0],
                  },
                ],
                {
                  image: barcode,
                  width: 150,
                  height: 50,
                },
              ],
            },
            {
              text: `Catatan Pembeli: ${picker.order_note || '-'}`,
              margin: [0, 5, 0, 0],
              alignment: 'left',
            },
          ],
        ],
      },
      content: [
        {
          style: 'tableContent',
          table: {
            dontBreakRows: true,
            headerRows: 1,
            widths: [90, 110, 280, 40],
            body: bodyDataIntoTable,
          },
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        tableContent: {
          margin: [0, 0, 0, 15],
          alignment: 'center',
        },
        tableText: {
          margin: [0, 5, 0, 10],
        },
        blockedText: {
          margin: [0, 5, 0, 10],
          background: '#000000',
          color: '#FFFFFF',
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black',
        },
      },
    }
    printPdfMake(documentDefinition)
    /**
         *  Safari
            pdfMake.createPdf(content).open({}, window.frames['printPdf']);
                setTimeout(function() {
                window.frames['printPdf'].focus();
                window.frames['printPdf'].print();
            }, 2000)
         */
  })
}

export const printCloudKitchenModifierLabel = async (order, productQty) => {
  if (!window.pdfMake) {
    toastFailed('PdfMake is not ready')
    return
  }

  let receiptAstroKitchen = []

  const orderProductNameParser = (productName, i, withModifier) => {
    let productNameParsed = productName
    const MAX_WORD_LENGTH = withModifier ? 35 : 55
    if (productName.length > MAX_WORD_LENGTH) {
      productNameParsed = `${productName.substr(0, MAX_WORD_LENGTH)}...`
    }
    const splitProductNameBy = productName.split('-')
    const lastWord = splitProductNameBy[splitProductNameBy.length - 1]
    const variant = lastWord.toLowerCase().includes('large')
      ? 'LARGE'
      : lastWord.toLowerCase().includes('regular')
      ? 'REGULAR'
      : ''
    let stack = [
      {
        text: productNameParsed,
        fontSize: 9,
        bold: true,
        margin: [0, 7, 0, variant !== '' ? 0 : 4],
        ...(i !== 0 && { pageBreak: 'before' }),
      },
    ]
    if (variant !== '') {
      stack = [
        ...stack,
        {
          table: {
            widths: 'auto',
            body: [
              [
                {
                  border: [true, true, true, true],
                  text: variant,
                  bold: true,
                  style: {
                    fontSize: 5,
                    padding: 1,
                  },
                },
              ],
            ],
          },
          margin: [0, 2, 0, 4],
        },
      ]
    }
    return stack
  }
  const modifiersParser = (modifiersList) => {
    const modifierLimit = 5
    const catatan = {
      text: `Catatan (${modifiersList.length})`,
      fontSize: 5,
      bold: true,
      margin: [0, 0, 0, 2],
    }
    const listModifiers = modifiersList
      .map((addOn) => addOn.modifier_variants.map((variant) => variant.name))
      .flat()
    if (modifiersList.length === 0) return [catatan]
    const limitedModifiers =
      listModifiers.length >= modifierLimit ? listModifiers.slice(0, 5) : listModifiers
    return [
      catatan,
      {
        table: {
          widths: ['*'], // Use full width for the text
          body: limitedModifiers.map((name) => [
            {
              text: name.length > 20 ? `${name.substr(0, 45)}...` : name,
              margin: [0, 0, 0, 0],
              fontSize: 4,
              alignment: 'left', // Align text to the left
              lineHeight: 0,
            },
          ]),
        },
        layout: 'noBorders', // Remove borders for a cleaner look
      },
    ]
  }
  const addOnsParser = (addOns) => {
    const TOPPING_CHAR_LIMIT = 3
    const AddOnsOverFlowInfo = {
      stack: [
        {
          text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -',
          fontSize: 5,
          alignment: 'center',
        },
        {
          text: '* CATATAN LENGKAP LIHAT APLIKASI *',
          bold: true,
          italics: true,
          margin: [0, -2, 0, 0],
          fontSize: 5,
          alignment: 'center',
        },
      ],
    }
    const topping = addOns
      .map((addOn) => addOn.modifier_variants.map((variant) => variant.name))
      .flat() // Create a flat array of add-on names

    const tambahan = {
      text: `Tambahan (${addOns.length})`,
      fontSize: 5,
      bold: true,
      margin: [0, 0, 0, 2],
    }
    if (addOns.length === 0)
      return {
        stack: [tambahan],
        absolutePosition: { x: 5, y: 90 },
      }
    const limitedTopping = topping.length >= TOPPING_CHAR_LIMIT ? topping.slice(0, 3) : topping
    let stackParsed = [
      tambahan,
      {
        table: {
          widths: ['*'], // Use full width for the text
          body: limitedTopping.map((name) => [
            {
              text: name.length > 20 ? `${name.substr(0, 45)}...` : name,
              margin: [0, 0, 0, 0],
              fontSize: 4,
              alignment: 'left', // Align text to the left
              lineHeight: 0,
            },
          ]),
        },
        layout: 'noBorders', // Remove borders for a cleaner look
      },
    ]
    if (topping.length >= TOPPING_CHAR_LIMIT) {
      stackParsed = [...stackParsed, AddOnsOverFlowInfo]
    }
    return {
      stack: stackParsed,
      absolutePosition: topping.length >= TOPPING_CHAR_LIMIT ? { x: 5, y: 83 } : { x: 5, y: 90 },
    }
  }

  const CustomerInfoAndQR = (customer, itemId, orderId, customerNote) => ({
    stack: [
      {
        text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -',
        fontSize: 5,
      },
      {
        columns: [
          {
            stack: [
              { text: `${customer}`, bold: true },
              { text: `Item ID: ${itemId}` },
              { text: `Order ID: ${orderId}` },
            ],
            style: {
              fontSize: 6,
            },
          },
          { qr: `kitchen-${itemId}`, fit: 42, alignment: 'center' },
        ],
      },
    ],
    style: {
      margin: [2, 0, 0, 0],
    },
    absolutePosition: { x: 5, y: 110 },
  })

  order.forEach((item, index) => {
    const { customer, customerNote, modifiers, productName, itemId, orderId, addOns } = item

    receiptAstroKitchen = [
      ...receiptAstroKitchen,
      orderProductNameParser(productName, index, modifiers.length > 0),
      ...modifiersParser(modifiers),
      addOnsParser(addOns),
      CustomerInfoAndQR(customer, itemId, orderId, customerNote),
    ]
  })

  const documentDefinition = {
    pageSize: { width: 113.386, height: 170.079 },
    pageMargins: [5, 5, 5, 5],
    pageOrientation: 'portrait',
    content: receiptAstroKitchen,
  }

  printPdfMake(documentDefinition)
}

export const printCloudKitchenLabel = async (order, productQty) => {
  if (!window.pdfMake) {
    toastFailed('PdfMake is not ready')
    return
  }

  let content = []
  order.forEach((d, index) => {
    const { invoice, customer, sku, name, product_note, page, total } = d
    const barcode = textToBase64Barcode(sku)
    content = [
      ...content,
      {
        columns: [
          [
            {
              fontSize: 5,
              margin: [0, 0, 10, 5],
              width: 100,
              text: invoice,
              pageBreak: index === 0 ? '' : 'before',
            },
            {
              fontSize: 8,
              bold: true,
              margin: [0, 0, 10, 5],
              text: customer,
            },
            {
              image: barcode,
              width: 80,
              margin: [-3, 0, 0, 5],
            },
            {
              fontSize: 5,
              margin: [0, 0, 2, 5],
              text: `SKU: ${sku}`,
            },
            {
              fontSize: 6,
              bold: true,
              margin: [0, 0, 150, 5],
              text: `${page} / ${total}`,
            },
            {
              fontSize: 8,
              bold: true,
              margin: [0, 0, 210, 5],
              text: name,
            },
            {
              fontSize: 5,
              bold: true,
              margin: [0, 0, 210, 5],
              text: product_note,
            },
          ],
        ],
      },
    ]
  })

  const documentDefinition = {
    pageSize: 'A6',
    pageMargins: [5, 10, 5, 5],
    pageOrientation: 'portrait',
    content,
  }

  printPdfMake(documentDefinition)
}

export const printPDF = async ({
  pageSize = 'A5',
  pageMargins = [24, 24, 24, 24],
  pageOrientation = 'portrait',
  content = [],
  styles = {},
}) => {
  try {
    if (!window.pdfMake) {
      toastFailed('PdfMake is not ready')
      return
    }

    const documentDefinition = {
      pageSize,
      pageMargins,
      pageOrientation,
      content,
      styles,
    }

    printPdfMake(documentDefinition)
  } catch {
    // do nothing
  }
}

export const printKitchenDriverPin = ({ driverPin, externalOrderId, isModifierLabel }) => {
  const pin = String(driverPin ?? '').trim()
  if (!pin) return

  printPDF({
    pageSize: isModifierLabel ? { width: 113.386, height: 170.079 } : 'A6',
    pageMargins: [8, 16, 8, 8],
    content: [
      { text: 'PIN DRIVER', fontSize: 12, bold: true, alignment: 'center' },
      {
        text: pin,
        fontSize: Math.min(36, 150 / pin.length),
        bold: true,
        alignment: 'center',
        margin: [0, 18, 0, 18],
      },
      { text: externalOrderId || '', fontSize: 10, bold: true, alignment: 'center' },
    ],
  })
}
